import { FETCH_INDICATORS, FETCHED_INDICATORS, SEARCH_INDICATORS, SELECT_INDICATOR, SELECT_ALL_INDICATORS, SELECT_INDICATOR_ON_RESULT } from './IndicatorsActions'




const indicatorsReducer = (state = { searchParameter: "", indicators: [], isFetching: false }, action) => {

    const searchIndicators = (indicator, activeLangCode) => {
        let indicatorTested = { ...indicator, isMatchSearch: false }
        if (action.searchParameter === "") {
            indicatorTested.isMatchSearch = true;
            return indicatorTested;
        }

        if (indicator['n_' + action.activeLangCode].toLowerCase().includes(action.searchParameter ? action.searchParameter.toLowerCase() : state.searchParameter.toLowerCase())) {
            indicatorTested.isMatchSearch = true;
        }

        return indicatorTested;
    }

    switch (action.type) {
        case FETCH_INDICATORS:
            return {
                ...state,
                isFetching: true
            }
        case FETCHED_INDICATORS:
            return {
                isFetching: false,
                searchParameter: "",
                indicators: action.data.map(t => ({ ...t, isMatchSearch: true }))
            }
        case SEARCH_INDICATORS:
            return {
                ...state,
                searchParameter: action.searchParameter,
                indicators: state.indicators.map(searchIndicators)
            }
        case SELECT_INDICATOR:
            return {
                ...state,
                indicators: state.indicators.map((indicator) => {
                    if (indicator.id === action.indicatorId) {
                        return { ...indicator, selected: !indicator.selected, selectedOnResult: false }
                    }
                    return {...indicator, selectedOnResult: false}
                })
            }
        case SELECT_ALL_INDICATORS:
            return {
                ...state,
                indicators: state.indicators.map((indicator, index) => {
                    return { ...indicator, selected: action.selectionStatus === "ALL" || action.selectionStatus === "SOME" ? false : true, selectedOnResult: false }
                })
            }
        case SELECT_INDICATOR_ON_RESULT:
        return {
            ...state,
            indicators: state.indicators.map((indicator) => {
                if (indicator.id === action.indicatorId) {
                    return { ...indicator, selectedOnResult: true }
                }
                return { ...indicator, selectedOnResult: false }
            })
        }
        default:
            return state;
    }
}

export default indicatorsReducer;


// WEBPACK FOOTER //
// ./src/features/modules/survey-data-visualization/indicators/IndicatorsReducer.js